import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import MainLayout from '@/components/layouts/MainLayout.vue';
import ProfileIndexPage from '@/pages/profile/ProfileIndexPage.vue';

import businessRoutes from '@/routes/business.routes';
import ownersRoutes from '@/routes/owners.routes';
import userRoutes from '@/routes/user.routes';
import bankingRoutes from '@/routes/banking.routes';
import financialRoutes from '@/routes/financial.routes';
import verificationRoutes from '@/routes/verification.routes';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/profile',
  component: MainLayout,
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    displayNav: true,
  },
  children: [
    {
      path: '',
      name: RouteNames.PROFILE.INDEX,
      alias: '/pay-vendors/business-profile',
      component: ProfileIndexPage,
      children: [
        ...businessRoutes,
        ...userRoutes,
        ...ownersRoutes,
        ...bankingRoutes,
        ...financialRoutes,
        ...verificationRoutes,
      ],
    },
  ],
});
